import React from 'react';
import PageLayout from '../../layout/PageLayout';
import KimCustomersSuppliers from '../../layout/KimGroup/KimCustomersSuppliers';

const KimCustomersSuppliersPage: React.FC = () => (
  <PageLayout>
    <KimCustomersSuppliers />
  </PageLayout>
);

export default KimCustomersSuppliersPage;
